import React, {Component} from 'react';
import {connect} from 'react-redux';
// import {WarningTwoTone} from '@ant-design/icons';
import AuthActions from 'bukku/redux/Auth/actions';
import StyledLoading from './style';
// import {Trans} from "@lingui/macro";
import { CompanySelectPage } from './CompanySelectPage';
import { WarningTwoTone } from '@ant-design/icons';
import { Trans } from '@lingui/macro';

const {
    logout,
} = AuthActions;

const urlDomain = process.env.REACT_APP_URL_DOMAIN;

class Loading extends Component {
    quotes = [
        {
            author: "Chris Grosser",
            quote: "Opportunities don't happen. You create them.",
        },
        {
            author: "John D. Rockefeller",
            quote: "Don't be afraid to give up the good to go for the great.",
        },
        {
            author: "Thomas Jefferson",
            quote: "I find that the harder I work, the more luck I seem to have.",
        },
        {
            author: "Tony Hsieh",
            quote: "Stop chasing the money and start chasing the passion.",
        },
        {
            author: "Michael John Bobak",
            quote: "All progress takes place outside the comfort zone.",
        },
        {
            quote: "Business opportunities are like buses, there’s always another one coming.",
            author: "Richard Branson",
        },
        {
            quote: "Every problem is a gift—without problems we would not grow.",
            author: "Anthony Robbins",
        },
        {
            quote: "You only have to do a few things right in your life" +
                "so long as you don’t do too many things wrong.",
            author: "Warren Buffett",
        },
        {
            quote: "Success usually comes to those who are too busy to be looking for it.",
            author: "Henry David Thoreau",
        },
        {
            quote: "There’s no shortage of remarkable ideas, what’s missing is the will to execute them.",
            author: "Seth Godin",
        },
        {
            quote: "If you really look closely, most overnight successes took a long time.",
            author: "Steve Jobs",
        },
        {
            quote: "Imagination is everything. It is the preview of life’s coming attractions.",
            author: "Albert Einstein",
        },
        {
            quote: "The way to get started is to quit talking and begin doing.",
            author: "Walt Disney",
        },
        {
            quote: "I feel that luck is preparation meeting opportunity.",
            author: "Oprah Winfrey",
        },
        {
            quote: "I never dreamed about success. I worked for it.",
            author: "Estée Lauder",
        },
        {
            quote: "The only place where success comes before work is in the dictionary.",
            author: "Vidal Sassoon",
        },
        {
            quote: "The only way around is through.",
            author: "Robert Frost",
        },
    ];

    quoteIdx = 0;

    constructor(props) {
        super(props);

        this.quoteIdx = Math.floor(Math.random() * this.quotes.length);
    }

    getQuoteText = () => this.quotes[this.quoteIdx].quote;

    getQuoteAuthor = () => this.quotes[this.quoteIdx].author;

    renderLoading = () => (
        <div className="spinner">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
        </div>
    );

    render() {
        const {
            validateSessionState,
            validateSessionErrorStatusCode,
            logout,
            sessionReady,
            history,
            // parent
            showLoading,
        } = this.props;

        if (window.location.hostname === `app.${urlDomain}`) {
            // if (window.location.hostname === 'app.bukku.my' || isDebugAppBukkuMy) {
            return (
                <CompanySelectPage />
            );
        }

        if (validateSessionState === 'error') {
            const isRateLimited = validateSessionErrorStatusCode === 429;
            const message = isRateLimited
                ? <Trans>Too many requests, please try again later.</Trans>
                : <Trans>No Access to Company URL</Trans>;
            const actionLabel = isRateLimited ? <Trans>Refresh</Trans> : <Trans>Logout</Trans>;
            const onAction = isRateLimited
                ? () => window.location.reload()
                : () => {
                    logout();
                    history.push('/signin');
                };

            // already logged in, redirected from bukku.my's LOGIN button
            return (
                <StyledLoading>
                    <div className="content">
                        <WarningTwoTone twoToneColor="#f5222d" />
                        <p className="message">{message}</p>
                        <p className="button">
                            <button className="link" onClick={onAction} type="button">
                                {actionLabel}
                            </button>
                        </p>
                    </div>
                </StyledLoading>
            );
        }

        if (showLoading || validateSessionState === 'request' || !sessionReady) {
            return (
                <StyledLoading>
                    <div className="content">
                        <img src="/assets/img/logo/logo-landscape-light.png" alt="" />
                        <div className="quote">
                            <p className="text">
                                {this.getQuoteText()}
                            </p>
                            <p className="author">{this.getQuoteAuthor()}</p>
                        </div>
                        <div className="loading">
                            {this.renderLoading()}
                        </div>
                    </div>
                </StyledLoading>
            );
        }
        return null;
    }
}
export default connect(state => ({
    validateSessionState: state.Auth.validateSessionState,
    validateSessionErrorStatusCode: state.Auth.validateSessionErrorStatusCode,
    sessionReady: state.Auth.sessionReady,
}), {
    logout,
})(Loading);
